<template>
  <div>
    <!--标题-->
    <div class="detailsTitle">
      <h4>汽运结算</h4>
    </div>
    <!--查询条件-->
    <div class="searchBox" ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="100px" size="mini">
        <div class=" inpBox">
          <el-form-item label="结算单号:" prop="billNumber">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom.billNumber"></el-input>
          </el-form-item>
          <el-form-item label="司机姓名:" prop="driverName">
            <el-input  placeholder="" maxlength="100" v-model="searchFrom.driverName"></el-input>
          </el-form-item>
          <el-form-item label="司机所属:" prop="vehicleType">
            <el-select v-model="searchFrom.vehicleType" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in vehicleTypeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
          <el-form-item label="账单状态:" prop="qybillState">
            <el-select v-model="searchFrom.qybillState" placeholder="请选择">
                  <el-option
                    v-for="(item,index) in qybillStateOptions"
                    :key="index"
                    :label="item.showName"
                    :value="item.itemNo">
                  </el-option>
                </el-select>
          </el-form-item>
        </div>
       <div class="searchBtnBox">
        <el-form-item>
          <el-button type="primary" @click="searchClick" btnCode='000P00SB001' v-if="btnFlg[0]">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="resetClick" btnCode='000P00SB002' v-if="btnFlg[1]">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addBtnClick"  btnCode='000P00SB003' v-if="btnFlg[2]">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="changeBtnClick" btnCode='000P00SB004' v-if="btnFlg[3]">修改</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="delClick" btnCode='000P00SB005' v-if="btnFlg[4]">删除</el-button>
        </el-form-item>
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table
        :data="tableList"
        ref="tableRef"
        border
        bordersize="mini"
        height="91%"
        style="width: 100%;margin-top:10px;"
        center
        @row-click="dianjixuanzhong"
        @current-change="handleTabCurrentChange"
        :header-cell-style="{background:'#F5F5F5',color:'black'}"
        :header-row-style="{height:'45px'}"
        :row-style="{height:'35px'}"
        highlight-current-row>
        <el-table-column  type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
        <el-table-column prop="billNumber"    label="结算单号"  align="center" >
          <template slot-scope="scope"><div>
            <el-button type="text" size="mini" @click="billNumberClick(scope.row)" >{{scope.row.billNumber}}</el-button>
          </div></template>
        </el-table-column>
        <el-table-column prop="driverName"   label="司机姓名" align="center" ></el-table-column>
        <el-table-column prop="driverMobile"   label="联系方式" align="center" ></el-table-column>
        <el-table-column prop="ext2"   label="司机所属" align="center" ></el-table-column>
        <el-table-column prop="ext3" label="结算方式" align="center" ></el-table-column>
        <el-table-column prop="bankCard"   label="银行卡号" align="center" ></el-table-column>
        <el-table-column prop="bankName"   label="开户行" align="center" ></el-table-column>
        <el-table-column prop="totalSum" label="费用合计"  align="center" ></el-table-column>
        <el-table-column prop="qybillType" label="结算方式" align="center" >
          <template slot-scope="scope"><div>
            <span  v-if="scope.row.qybillType == '1'">票到付款</span>
            <span v-else-if="scope.row.qybillType == '2'">货到付款</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="qybillState" label="结算状态"  align="center" >
          <template slot-scope="scope"><div>
            <span  v-if="scope.row.qybillState == '1'">未结算</span>
            <span v-else-if="scope.row.qybillState == '2'">已结算</span>
          </div></template>
        </el-table-column>
        <el-table-column prop="createTime"   label="创建时间" align="center" :formatter="dateFormat"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 10,25,50,100-->
    <div >
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNum"
        :page-sizes="[1,10,25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增-->
    <el-dialog :title="title"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="addMark"
    @close="closeDialog('addFrom')"
    width="900px"
    center>
      <span>
         <el-form
          :model="addFrom"
          ref="addFrom"
          :rules="rules"
          :validate-on-rule-change = "false"
          class="demo-form-inline"
          label-width="140px" size="mini">
        <div class="addinpBox" >
          <el-form-item  label="司机所属"
            prop='vehicleType'
            style="margin-top:20px;">
            <el-select v-model="addFrom.vehicleType" :validate-event = "false" filterable clearable placeholder="请选择" style="width:240px;">
                 <el-option
                    v-for="(item,index) in vehicleTypeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
          <el-form-item  label="司机姓名"
            prop='driverName'
            style="margin-top:20px;">
            <el-select v-model="addFrom.driverName" @change="driverNameChange" :validate-event = "false" filterable clearable placeholder="请选择" style="width:240px;">
                 <el-option
                    v-for="(item,index) in driverNameOptions"
                    :key="index"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
          </el-form-item>
          <el-form-item  label="司机电话"
            prop='driverMobile'
            style="margin-top:20px;">
            <el-input  placeholder="" maxlength="" v-model="addFrom.driverMobile" disabled :validate-event = "false" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item  label="银行卡号"
            prop='bankCard'
            style="margin-top:20px;">
            <el-input  placeholder="" maxlength="" v-model="addFrom.bankCard" disabled :validate-event = "false" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item  label="开户行"
            prop='bankName'
            style="margin-top:20px;">
            <el-input  placeholder="" maxlength="" v-model="addFrom.bankName" disabled :validate-event = "false" style="width:240px;"></el-input>
          </el-form-item>
          <el-form-item  label="费用费目"
            prop='cost'
            style="margin-top:20px;">
            <el-checkbox v-model="checkAll" @change="handleCheckAllChange" >全选</el-checkbox>
              <el-checkbox  v-model="addFrom.cost"
                v-for="(item,index) in checkData"
                :checked='checkedFlg'
                :key="index"
                :label="item.id"
                :validate-event = "false"
                @change="handleCheckedCitiesChange">{{item.feeName}}</el-checkbox>
            </el-form-item>
          <el-form-item  label="结算方式"
            prop='qybillType'
            style="margin-top:20px;">
            <el-select v-model="addFrom.qybillType" :validate-event = "false" placeholder="请选择" style="width:240px;">
                 <el-option
                    v-for="(item,index) in qybillTypeOptions"
                    :key="index"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
          </el-form-item>
          <el-form-item  label="结算月份"
            prop='settlementMonth'
            style="margin-top:20px;">
            <el-date-picker
              v-model="addFrom.settlementMonth"
              type="daterange"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
        </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size='mini'   @click="addSubmit('addFrom')" :loading='addLoading' v-if="addBtnShow">保存</el-button>
        <el-button type="primary" size='mini'   @click="changeSubmit('addFrom')" :loading='changeLoading' v-if="changeBtnShow">修改</el-button>
        <el-button @click="addSpuClose('addFrom')" size='mini'>取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  settlementBillAdd, // 新增
  settlementBillList, // 列表
  listBySysModel, // 新增-费目多选框数据
  seeGroupType, // 获取字典表下拉框数据
  settlementBillDelete // 删除
} from '@/api/platform-settlement'
import DonMessage from '@/utils/message'
// eslint-disable-next-line no-unused-vars
import { getBtn } from '@/utils/getButton'
import axios from 'axios'
import store from '@/store'
export default {
  data () {
    return {
      // 按钮
      btnFlg: [],
      btnIdArr: ['000P00SB001', '000P00SB002', '000P00SB003', '000P00SB004', '000P00SB005'],
      feeId: '',
      title: '',
      h: '500px',
      total: 0,
      searchFrom: {
        sysModel: '4',
        pageNo: 1,
        pageSize: 10
      },
      // 开票状态
      invoiceStateOptions: [{
        value: '1',
        label: '已开票'
      }, {
        value: '2',
        label: '未开票'
      }],
      // 结算单状态
      qybillStateOptions: [],
      // 司机所属
      vehicleTypeOptions: [{
        value: '2',
        label: '自家'
      }
      // {
      //   value: '1',
      //   label: '市场'
      // }
      ],
      value: '',
      tableList: [],
      tableHeardArr: [],
      attrName: '', // 表头信息
      // 新增
      customerNameOptions: [], // 客户名称
      driverNameOptions: [],
      addFrom: {
        cost: [], // 费用费目
        costStr: '',
        vehicleType: '', // 司机所属
        driverName: '', // 司机姓名
        siJiName: '', // 司机name值
        driverMobile: '', // 司机电话
        bankCard: '', // 银行卡号
        bankName: '', // 开户行
        qybillType: '', // 结算方式
        settlementMonth: [] // 结算月份
      },
      checkAll: true,
      isIndeterminate: true,
      checkedFlg: true,
      checkData: [],
      checkDataStr: '',
      addLoading: false,
      settlementTypeOptions: [],
      qybillTypeOptions: [{
        value: '1',
        label: '票到付款'
      }
      // {
      //   value: '1',
      //   label: '市场'
      // }
      ],
      monthShow: false, // 结算月份的显示隐藏
      rules: {
        vehicleType: [
          { required: true, message: '司机所属不能为空！', trigger: 'blur' }
        ],
        driverName: [
          { required: true, message: '司机姓名不能为空！', trigger: 'blur' }
        ],
        driverMobile: [
          { required: true, message: '司机电话不能为空！', trigger: 'blur' }
        ],
        settlementMonth: [
          { required: true, message: '结算月份不能为空！', trigger: 'blur' }
        ],
        cost: [
          { required: true, message: '费用费目不能为空！', trigger: 'blur' }
        ],
        qybillType: [
          { required: true, message: '结算方式不能为空！', trigger: 'blur' }
        ]
      },
      selectData: '',
      addBtnShow: false,
      changeBtnShow: false,
      // 修改
      addMark: false, // 新增弹框
      changeLoading: false,
      xuanzhongArr: [],
      delBtnShow: true,
      spuName: '',
      changeId: '',
      allElection: [], // 全选
      selectionArr: []
    }
  },
  created () {
    this.getSeatchData(this.searchFrom)
    this.getDistoryData()
    // this.feeId = localStorage.getItem('feeId')
    // this.spuName = localStorage.getItem('spuName')
    this.btnFlg = getBtn(this.btnIdArr, '/smpSettlement/QYjiesuandan')
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 150) + 'px'
  },
  methods: {
    // 点击主表选中需要修改的行
    dianjixuanzhong (row, column, event) {
      this.xuanzhongArr = row
      this.currentXQ = 1
      this.$refs.tableRef.toggleRowSelection(row)
    },
    // 获取字典表数据 - 结算单状态
    getDistoryData () {
      seeGroupType({
        groupNo: 'qybill_state'
      }).then(res => {
        this.qybillStateOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 查询接口
    getSeatchData () {
      settlementBillList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 点击查询按钮
    searchClick () {
      this.getSeatchData(this.searchFrom)
    },
    // 点击重置
    resetClick () {
      this.searchFrom = {
        sysModel: '4',
        pageNo: 1,
        pageSize: 10
      }
      this.getSeatchData(this.searchFrom)
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getSeatchData(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getSeatchData(this.searchFrom)
    },
    handleTabCurrentChange (val) {
      this.currentRow = val
    },

    // 司机姓名下拉框的值改变时
    driverNameChange (val) {
      this.driverNameOptions.forEach((item, index) => {
        if (item.id == val) {
          this.addFrom.driverMobile = item.mobile
          this.addFrom.bankCard = item.bankCard
          this.addFrom.bankName = item.bankName
        }
      })
    },
    // 获取司机信息
    getDriverNameData (url, options, excelName) {
      return new Promise((resolve, reject) => {
        axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8'
        axios({
          method: 'post',
          url: '/vgs-driver-server/driver/cDriverInfo/listNoPage', // 请求地址
          data: {}, // 参数
          // responseType: 'blob', // 表明返回服务器返回的数据类型
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
            Authorization: 'Bearer ' + store.getUser().access_token
          }
        }).then(response => {
          resolve(response.data)
          if (response.code == '0') {
            this.driverNameOptions = response.data
          }
        },
        err => {
          reject(err)
        }
        )
      })
    },
    // 获取费目多选框数据
    getListBySysModel () {
      listBySysModel({
        sysModel: '4'
      }).then(res => {
        this.checkData = res
      }).catch(err => {
        DonMessage.error(err.message)
      })
    },
    // 获取字典表数据 - 结算单状态
    getQyType () {
      seeGroupType({
        groupNo: 'qybill_type'
      }).then(res => {
        // this.qybillTypeOptions = res
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    // 全选
    handleCheckAllChange (val) {
      if (this.checkAll) {
        this.checkData.forEach(item => {
          this.addFrom.cost.push(item.id)
        })
      } else {
        this.addFrom.cost = []
      }
    },
    handleCheckedCitiesChange (value) {
      console.log(this.addFrom.cost)
      if (this.addFrom.cost.length == this.checkData.length) {
        this.checkAll = true
        this.checkedFlg = true
      } else {
        this.checkAll = false
        this.checkedFlg = false
      }
    },
    // 点击新建按钮
    addBtnClick () {
      this.addFrom.cost = []
      this.addMark = true
      this.addBtnShow = true
      this.changeBtnShow = false
      this.title = '新增结算单'
      this.getListBySysModel()
      this.getDriverNameData()
      this.getQyType()
      this.checkAll = true
      this.handleCheckAllChange()
      this.handleCheckedCitiesChange()
    },
    // 点击新增确定
    addSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkDataStr = [...new Set(this.addFrom.cost)].toString()
          let startTime = ''
          let endTime = ''
          if (this.addFrom.settlementMonth != null) {
            startTime = this.addFrom.settlementMonth[0]
            endTime = this.addFrom.settlementMonth[1]
          }
          // 同时获取司机下拉框的valu和lable值
          this.driverNameOptions.forEach((item, index) => {
            if (this.addFrom.driverName == item.id) {
              this.addFrom.siJiName = item.name
            }
          })
          this.addLoading = true
          settlementBillAdd({
            sysModel: '4',
            vehicleType: this.addFrom.vehicleType, // 司机所属
            driverName: this.addFrom.siJiName, // 司机姓名
            driverId: this.addFrom.driverName, // 司机id
            driverMobile: this.addFrom.driverMobile, // 司机电话
            bankCard: this.addFrom.bankCard, // 银行卡号
            bankName: this.addFrom.bankName, // 开户行
            feeId: this.checkDataStr, // 费目id
            billSdate: startTime, // 开始时间
            billEdate: endTime, // 结束时间
            qybillType: this.addFrom.qybillType // 结算方式
          }).then(res => {
            this.$message.success('添加成功！')
            this.addLoading = false
            this.getSeatchData(this.searchFrom)
            this.addMark = false
          }).catch(err => {
            this.addLoading = false
            this.$message.error(err.message)
          })
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 点击修改按钮
    changeBtnClick (row) {
      // let selectData = this.$refs.tableRef.selection
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else if (this.xuanzhongArr.qybillState != '1') {
        this.$message.error('只能修改未结算状态的数据！')
      } else {
        this.addMark = true
        this.title = '修改结算单'
        this.addBtnShow = false
        this.changeBtnShow = true
        this.checkAll = false
        this.getListBySysModel()
        this.getDriverNameData()
        this.getQyType()
        // console.log(this.xuanzhongArr, '/////')
        this.addFrom.vehicleType = this.xuanzhongArr.vehicleType
        this.addFrom.driverName = this.xuanzhongArr.driverId
        this.addFrom.driverMobile = this.xuanzhongArr.driverMobile
        this.addFrom.bankCard = this.xuanzhongArr.bankCard
        this.addFrom.bankName = this.xuanzhongArr.bankName
        this.addFrom.costStr = this.xuanzhongArr.feeId
        this.addFrom.cost = this.addFrom.costStr.split(',').map(Number)
        this.addFrom.qybillType = this.xuanzhongArr.qybillType
        this.addFrom.settlementMonth.push(this.xuanzhongArr.billSdateStr, this.xuanzhongArr.billEdateStr)
        if (this.addFrom.settlementMonth.length > '2') {
          this.addFrom.settlementMonth.splice(this.addFrom.settlementMonth[2], this.addFrom.settlementMonth.length - 2)
        }
        this.changeId = this.xuanzhongArr.id
      }
    },
    // 修改确定
    changeSubmit (formName) {
      // console.log(this.addFrom.formDataArr)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.checkDataStr = Array.from(new Set(this.changeFrom.cost)).filter(Boolean).toString()
          // this.checkDataStr = this.addFrom.cost.toString()
          let startTime = ''
          let endTime = ''
          if (this.addFrom.settlementMonth != null) {
            startTime = this.addFrom.settlementMonth[0]
            endTime = this.addFrom.settlementMonth[1]
          }
          // 同时获取司机下拉框的valu和lable值
          this.driverNameOptions.forEach((item, index) => {
            if (this.addFrom.driverName == item.id) {
              this.addFrom.siJiName = item.name
            }
          })
          this.changeLoading = true
          settlementBillAdd({
            id: this.changeId,
            sysModel: '4',
            vehicleType: this.addFrom.vehicleType, // 司机所属
            driverName: this.addFrom.siJiName, // 司机姓名
            driverId: this.addFrom.driverName, // 司机id
            driverMobile: this.addFrom.driverMobile, // 司机电话
            bankCard: this.addFrom.bankCard, // 银行卡号
            bankName: this.addFrom.bankName, // 开户行
            feeId: this.checkDataStr, // 费目id
            billSdate: startTime, // 开始时间
            billEdate: endTime, // 结束时间
            qybillType: this.addFrom.qybillType // 结算方式
          }).then(res => {
            this.$message.success('修改成功！')
            this.changeLoading = false
            this.getSeatchData(this.searchFrom)
            this.addMark = false
          }).catch(err => {
            this.changeLoading = false
            this.$message.error(err.message)
          })
          // console.log(name)
        } else {
          // console.log('error submit!!');
          return false
        }
      })
    },
    // 取消
    addSpuClose (formName) {
      this.addMark = false
      this.$refs[formName].resetFields()
      this.addFrom.vehicleType = ''
      this.addFrom.driverName = ''
      this.addFrom.siJiName = ''
      this.addFrom.driverMobile = ''
      this.addFrom.bankCard = ''
      this.addFrom.bankName = ''
      this.addFrom.qybillType = ''
      this.addFrom.settlementMonth = []
      // this.checkedMore = []
      // if (this.checkData.length > '1') {
      //   this.addFrom = {
      //     // cost: [], // 费用费目
      //     costStr: '',
      //     vehicleType: '', // 司机所属
      //     driverName: '', // 司机姓名
      //     siJiName: '', // 司机name值
      //     driverMobile: '', // 司机电话
      //     bankCard: '', // 银行卡号
      //     bankName: '', // 开户行
      //     qybillType: '', // 结算方式
      //     settlementMonth: [] // 结算月份
      //   }
      // }

      // console.log('2222')
    },
    closeDialog (formName) {
      this.$refs[formName].resetFields()
    },
    // 点击删除
    delClick () {
      // console.log(this.xuanzhongArr,'222')
      // eslint-disable-next-line no-unused-vars
      let selectData = this.$refs.tableRef.selection
      // console.log(selectData.length,'222')
      if (this.xuanzhongArr.length == 0) {
        this.$message.error('请选择一条数据进行操作！')
      } else if (this.xuanzhongArr.length > 1) {
        this.$message.error('只能选择一条数据进行操作！')
      } else if (this.xuanzhongArr.qybillState != '1') {
        this.$message.error('只能删除未结算状态的数据！')
      } else {
        this.$confirm('是否确定删除？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            settlementBillDelete({
              id: this.xuanzhongArr.id // id
            })
              .then(res => {
                DonMessage.success('操作成功!')
                this.getSeatchData(this.searchFrom)
              })
              .catch(err => {
                DonMessage.error(err.message)
              })
          // eslint-disable-next-line handle-callback-err
          }).catch(err => {
            // DonMessage.error(err.message)
          })
      }
    },
    // 跳转详情
    billNumberClick (row) {
      localStorage.setItem('cangChuId', row.id)
      this.$router.push('/smpSettlement/transportDetails')
    },
    // 时间格式化
    dateFormat: function (row, column, cellValue) {
      var t = new Date(cellValue) // row 表示一行数据, transferTime 表示要格式化的字段名称
      var month =
        t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
      var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
      var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
      var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
      var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
      return (
        t.getFullYear() +
        '-' +
        month +
        '-' +
        date +
        ' ' +
        hour +
        ':' +
        minutes +
        ':' +
        seconds
      )
      // return t.getFullYear() + "-" + (t.getMonth() + 1) + "-" + t.getDate(); // 年月日
    }
  }
}
</script>
<style scoped lang='less'>
.el-table{
overflow:visible !important;
}
.searchBox{
  margin-left: 10px;
}
.inpBox{
  margin: 10px 0 0 -30px;
}

 /deep/ .inpBox .el-range-editor--mini .el-input__inner {
   width: 150px;
}
.searchBtnBox{
  margin-top: 10px;
}
.el-date-editor.el-input, .el-date-editor.el-input__inner {
    width:  240px;
    // background-color:#fff;
}
.el-table__header tr,
  .el-table__header th {
    padding: 0;
    height: 40px;
}
//  .demo-form-inline .el-form-item{
//   margin-bottom: 17px!important;
// }
</style>
